<script lang="ts">
    import { Link, useForm, page } from '@inertiajs/svelte';
    import { login } from '@/routes';

    const form = useForm({ email: '' });

    const errors = $derived($page?.props?.errors ?? {});
    const status = $derived($page?.props?.flash?.status);

    function submit(e: SubmitEvent) {
        e.preventDefault();
        $form.post('/forgot-password');
    }
</script>

<svelte:head>
    <title>Forgot Password — Case of the Day</title>
</svelte:head>

<div class="min-h-screen flex items-center justify-center bg-gray-950">
    <div class="bg-gray-900 rounded-lg shadow border border-gray-700 p-8 w-full max-w-lg">
        <h1 class="text-2xl font-bold text-gray-100 mb-2">Forgot Password</h1>
        <p class="text-sm text-gray-400 mb-6">Enter your email and we'll send you a link to reset your password.</p>

        {#if status}
            <div class="mb-4 rounded-md bg-green-50 border border-green-200 p-3 text-sm text-green-700">
                {status}
            </div>
        {/if}

        <form onsubmit={submit} class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Email</label>
                <input
                    bind:value={$form.email}
                    type="email"
                    autocomplete="email"
                    required
                    class="w-full border rounded px-3 py-2 text-sm bg-gray-800 text-gray-100 {errors.email ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.email}<p class="text-red-500 text-sm mt-1">{errors.email}</p>{/if}
            </div>
            <button type="submit" disabled={$form.processing} class="w-full bg-cyan-600 text-white py-2 rounded text-sm hover:bg-cyan-500 disabled:opacity-50">
                Send Reset Link
            </button>
        </form>

        <p class="mt-4 text-center text-sm text-gray-400">
            <Link href={login()} class="text-cyan-400 hover:text-cyan-300 hover:underline">Back to Sign In</Link>
        </p>
    </div>
</div>
